export default "__VITE_ASSET__d491b111__"